import React from 'react'
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

export default function TrendingCollectionsCategoryWise() {

  const options = {
    margin: 10,
    items: 3,
    loop: true,
    autoplay: true,
    autoplayTimeout: 3500,
    autoplaySpeed: 1000,
    onChanged: handleSlideChange,
    dots: false,
    responsive: {
      0: {
        items: 1, // 1 slide in responsive mode
      },
      768: {
        items: 3, // 3 slides on desktop
      },
    },
  };

  function handleSlideChange(event) {
    console.log('Active item:', event.item.index);
  }

  return (
<div className="author-wrapper dark-bg">
  <div className="container pb-lg-5">
    <div className="row">
      <div className="col-12 d-flex">
        <h2 className="text-gray-900 rajdhani-600 h1 mb-0 dark-text">Trending Collentions</h2>
        <select className="form-select rounded-10 w-150 font-sm light-bg dark-border dark-text text-gray-900 rajdhani-600 bg-transparent ms-auto" aria-label="select example">
          <option value>Sort by</option>
          <option value={1}>High to Low</option>
          <option value={2}>Low to High</option>
          <option value={3}>Price</option>
        </select>
      </div>
    </div>
    <div className="row mt-lg-5 mt-3">
      <OwlCarousel className="owl-carousel owl-theme three-nft dot-disabled author-collection" {...options}>
        <div className="item mb-3">
          <div className="nft-div border dark-border dark-bg3 rounded-10 p-2 mt-3">
            <div className="d-flex gap-2 p-1">
              <figure className="avater mb-0"><img src="images/artist-3.jpg" alt="user" className="w-45 rounded-pill" /></figure>
              <div className="d-flex flex-column">
                <h5 className="rajdhani-600 text-gray-900 h6 d-flex lh-18 gap-1 mb-0 mt-1 dark-text">@deoxclub <i className="bi-patch-check-fill font-xs text-success" /></h5>
                <span className="font-xss rajdhani-500 text-gray-500 d-flex gap-1">223 Collections</span>
              </div>
              <i className="btn btn-icon btn-md rounded-pill ms-auto m-0 border dark-border bi-three-dots dark-text font-md" />
            </div>
            <div className="d-flex flex-column gap-2 p-1 mt-1 gap-2">
              <div className="d-flex flex-column w-100"><figure className="mb-0 rounded-6 w-100 bg-image-cover bg-no-repeat bg-image-center" style={{backgroundImage: 'url(images/avatar-6.jpeg)', height: 150}} /></div>
              <div className="d-flex flex-row gap-2 p-1 mt-1">
                <figure className="mb-0 rounded-6 h-110 w-32 bg-image-cover bg-no-repeat bg-image-center" style={{backgroundImage: 'url(images/avatar-2.jpeg)'}} />
                <figure className="mb-0 rounded-6 h-110 w-32 bg-image-cover bg-no-repeat bg-image-center" style={{backgroundImage: 'url(images/avatar-1.jpeg)'}} />
                <figure className="mb-0 rounded-6 h-110 w-32 bg-image-cover bg-no-repeat bg-image-center" style={{backgroundImage: 'url(images/avatar-4.jpeg)'}} />
              </div>
            </div>
          </div>
        </div>
        <div className="item mb-3">
          <div className="nft-div border dark-border dark-bg3 rounded-10 p-2 mt-3">
            <div className="d-flex gap-2 p-1">
              <figure className="avater mb-0"><img src="images/artist-1.jpg" alt="user" className="w-45 rounded-pill" /></figure>
              <div className="d-flex flex-column">
                <h5 className="rajdhani-600 text-gray-900 h6 d-flex lh-18 gap-1 mb-0 mt-1 dark-text">@moonbirds <i className="bi-patch-check-fill font-xs text-success" /></h5>
                <span className="font-xss rajdhani-500 text-gray-500 d-flex gap-1">43 Collections</span>
              </div>
              <i className="btn btn-icon btn-md rounded-pill ms-auto m-0 border dark-border bi-three-dots dark-text font-md" />
            </div>
            <div className="d-flex flex-column gap-2 p-1 mt-1 gap-2">
              <div className="d-flex flex-column w-100"><figure className="mb-0 rounded-6 w-100 bg-image-cover bg-no-repeat bg-image-center" style={{backgroundImage: 'url(images/avatar-5.jpeg)', height: 150}} /></div>
              <div className="d-flex flex-row gap-2 p-1 mt-1">
                <figure className="mb-0 rounded-6 h-110 w-32 bg-image-cover bg-no-repeat bg-image-center" style={{backgroundImage: 'url(images/avatar-3.jpeg)'}} />
                <figure className="mb-0 rounded-6 h-110 w-32 bg-image-cover bg-no-repeat bg-image-center" style={{backgroundImage: 'url(images/avatar-2.jpeg)'}} />
                <figure className="mb-0 rounded-6 h-110 w-32 bg-image-cover bg-no-repeat bg-image-center" style={{backgroundImage: 'url(images/avatar-4.jpeg)'}} />
              </div>
            </div>
          </div>
        </div>
        <div className="item mb-3">
          <div className="nft-div border dark-border dark-bg3 rounded-10 p-2 mt-3">
            <div className="d-flex gap-2 p-1">
              <figure className="avater mb-0"><img src="images/artist-2.jpg" alt="user" className="w-45 rounded-pill" /></figure>
              <div className="d-flex flex-column">
                <h5 className="rajdhani-600 text-gray-900 h6 d-flex lh-18 gap-1 mb-0 mt-1 dark-text">@panditcoast <i className="bi-patch-check-fill font-xs text-success" /></h5>
                <span className="font-xss rajdhani-500 text-gray-500 d-flex gap-1">43 Collections</span>
              </div>
              <i className="btn btn-icon btn-md rounded-pill ms-auto m-0 border dark-border bi-three-dots dark-text font-md" />
            </div>
            <div className="d-flex flex-column gap-2 p-1 mt-1 gap-2">
              <div className="d-flex flex-column w-100"><figure className="mb-0 rounded-6 w-100 bg-image-cover bg-no-repeat bg-image-center" style={{backgroundImage: 'url(images/avatar-3.jpeg)', height: 150}} /></div>
              <div className="d-flex flex-row gap-2 p-1 mt-1">
                <figure className="mb-0 rounded-6 h-110 w-32 bg-image-cover bg-no-repeat bg-image-center" style={{backgroundImage: 'url(images/avatar-2.jpeg)'}} />
                <figure className="mb-0 rounded-6 h-110 w-32 bg-image-cover bg-no-repeat bg-image-center" style={{backgroundImage: 'url(images/avatar-1.jpeg)'}} />
                <figure className="mb-0 rounded-6 h-110 w-32 bg-image-cover bg-no-repeat bg-image-center" style={{backgroundImage: 'url(images/avatar-4.jpeg)'}} />
              </div>
            </div>
          </div>
        </div>
        <div className="item mb-3">
          <div className="nft-div border dark-border dark-bg3 rounded-10 p-2 mt-3">
            <div className="d-flex gap-2 p-1">
              <figure className="avater mb-0"><img src="images/artist-4.jpg" alt="user" className="w-45 rounded-pill" /></figure>
              <div className="d-flex flex-column">
                <h5 className="rajdhani-600 text-gray-900 h6 d-flex lh-18 gap-1 mb-0 mt-1 dark-text">@alicegaose <i className="bi-patch-check-fill font-xs text-success" /></h5>
                <span className="font-xss rajdhani-500 text-gray-500 d-flex gap-1">43 Collections</span>
              </div>
              <i className="btn btn-icon btn-md rounded-pill ms-auto m-0 border dark-border bi-three-dots dark-text font-md" />
            </div>
            <div className="d-flex flex-column gap-2 p-1 mt-1 gap-2">
              <div className="d-flex flex-column w-100"><figure className="mb-0 rounded-6 w-100 bg-image-cover bg-no-repeat bg-image-center" style={{backgroundImage: 'url(images/avatar-4.jpeg)', height: 150}} /></div>
              <div className="d-flex flex-row gap-2 p-1 mt-1">
                <figure className="mb-0 rounded-6 h-110 w-32 bg-image-cover bg-no-repeat bg-image-center" style={{backgroundImage: 'url(images/avatar-3.jpeg)'}} />
                <figure className="mb-0 rounded-6 h-110 w-32 bg-image-cover bg-no-repeat bg-image-center" style={{backgroundImage: 'url(images/avatar-1.jpeg)'}} />
                <figure className="mb-0 rounded-6 h-110 w-32 bg-image-cover bg-no-repeat bg-image-center" style={{backgroundImage: 'url(images/avatar-2.jpeg)'}} />
              </div>
            </div>
          </div>
        </div>
      </OwlCarousel>
    </div>
  </div>
</div>

  )
}
